// Copyright (c) Docugami, Inc. All rights reserved.

const now: () => number = (typeof(window) !== "undefined" && window.performance && window.performance.now && (window.performance.now).bind(window.performance)) || Date.now;

export class Clock {
    private _isRunning: boolean = false;
    private _deltaTime: number = 0;
    private _currentTime: number = 0;
    private _elapsedTime: number = 0;

    get deltaTime(): number { return this._deltaTime; }
    get currentTime(): number { return this._currentTime; }
    get elapsedTime(): number { return this._elapsedTime; }

    start() {
        if (this._isRunning) {
            return;
        }

        this._currentTime = now();
        this._deltaTime = 0;
        this._elapsedTime = 0;
        this._isRunning = true;
    }

    stop() {
        this._isRunning = false;
    }

    tick(newTime: number = now()) {
        this._deltaTime = Math.max(newTime - this._currentTime, 0);
        this._currentTime = newTime;
        this._elapsedTime += this._deltaTime;
    }
}
